/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  let hasReloadedForUpdate = false;

  const reloadForUpdate = () => {
    if (hasReloadedForUpdate) return;

    hasReloadedForUpdate = true;
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener("controllerchange", reloadForUpdate);

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
    },
    registered() {
    },
    cached() {
    },
    updatefound() {
    },
    updated(registration) {
      // The new build must take control immediately so the next load uses the
      // latest integrations code rather than the stale PWA cache.
      registration.waiting?.postMessage({ type: "SKIP_WAITING" });
      window.setTimeout(reloadForUpdate, 250);
    },
    offline() {
     
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
